export class InviteModel {
  id?: number;
  first_name: string;
  last_name: string;
  npi: string;
  phone_number: string;
  email: string;
  status: string;
  created: string;
  role: { // Re-adding role object
    id: number;
    name: string;
  };
  role_id: number;
  role_name: string;
  constructor(invite: InviteModel) {
    this.id = invite.id;
    this.first_name = invite.first_name;
    this.last_name = invite.last_name;
    this.npi = invite.npi;
    this.phone_number = invite.phone_number;
    this.email = invite.email;
    this.status = invite.status;
    this.created = invite.created;
    this.role = invite.role; // Directly assigning the role object
    this.role_id = invite.role.id;
    this.role_name = invite.role.name; // Or this can be assigned here if only the id is needed
  }

  static fromObject(invite: InviteModel): InviteModel {
    return new InviteModel(invite);
  }

  static fromObjectArray(invites: InviteModel[]): InviteModel[] {
    return invites.map(InviteModel.fromObject);
  }
}
  export interface IResultInviteModel {
    count: number;
    next: string;
    previous: string;
    results: InviteModel[];
  }

  export class ResultInviteModel {
    count: number = 0;
    next: string;
    previous: string;
    results: InviteModel[] = [];

    constructor(result?: IResultInviteModel) {
      if (result) {
        this.count = result.count;
        this.next = result.next;
        this.previous = result.previous;
        this.results = ResultInviteModel.fromObjectArray(result.results);
      }
    }

    static fromObject(result: IResultInviteModel): ResultInviteModel {
      return new ResultInviteModel(result);
    }

    static fromObjectArray(results: InviteModel[]): InviteModel[] {
      return results.map(InviteModel.fromObject);
    }
  }
  // Model for NPI data
export interface INpiModel {
  id?: number;
  npi: string;
  phone_number: string | null;
  email: string | null;
  name: string;
  created: string | null;
  modified: string | null;
}

export class NpiModel {
  id?: number;
  npi: string;
  phone_number: string | null;
  email: string | null;
  name: string;
  created: string | null;
  modified: string | null;

  constructor(npi: INpiModel) {
    this.id = npi.id;
    this.npi = npi.npi;
    this.phone_number = npi.phone_number;
    this.email = npi.email;
    this.name = npi.name;
    this.created = npi.created;
    this.modified = npi.modified;
  }

  static fromObject(npi: INpiModel): NpiModel {
    return new NpiModel(npi);
  }

  static fromObjectArray(npis: INpiModel[]): NpiModel[] {
    return npis.map(NpiModel.fromObject);
  }
}

// Model for Role data
export interface IRoleModel {
  id?: number;
  name: string;
  verification_required: boolean;
  code: string;
  description: string;
  role_type: string;
  practice_required: boolean;
  created: string;
  modified: string;
  total: number;
}

export class RoleModel {
  id?: number;
  name: string;
  verification_required: boolean;
  code: string;
  description: string;
  role_type: string;
  practice_required: boolean;
  created: string;
  modified: string;
  total: number;

  constructor(role: IRoleModel) {
    this.id = role.id;
    this.name = role.name;
    this.verification_required = role.verification_required;
    this.code = role.code;
    this.description = role.description;
    this.role_type = role.role_type;
    this.practice_required = role.practice_required;
    this.created = role.created;
    this.modified = role.modified;
    this.total = role.total;
  }

  static fromObject(role: IRoleModel): RoleModel {
    return new RoleModel(role);
  }

  static fromObjectArray(roles: IRoleModel[]): RoleModel[] {
    return roles.map(RoleModel.fromObject);
  }
}

// Model for Result NPI List (similar to ResultInviteModel)
export interface IResultNpiModel {
  count: number;
  next: string | null;
  previous: string | null;
  results: INpiModel[];
}

export class ResultNpiModel {
  count: number = 0;
  next: string | null;
  previous: string | null;
  results: NpiModel[] = [];

  constructor(result?: IResultNpiModel) {
    if (result) {
      this.count = result.count;
      this.next = result.next;
      this.previous = result.previous;
      this.results = NpiModel.fromObjectArray(result.results);
    }
  }

  static fromObject(result: IResultNpiModel): ResultNpiModel {
    return new ResultNpiModel(result);
  }
}

// Model for Result Role List
export interface IResultRoleModel {
  count: number;
  next: string | null;
  previous: string | null;
  results: IRoleModel[];
}

export class ResultRoleModel {
  count: number = 0;
  next: string | null;
  previous: string | null;
  results: RoleModel[] = [];

  constructor(result?: IResultRoleModel) {
    if (result) {
      this.count = result.count;
      this.next = result.next;
      this.previous = result.previous;
      this.results = RoleModel.fromObjectArray(result.results);
    }
  }

  static fromObject(result: IResultRoleModel): ResultRoleModel {
    return new ResultRoleModel(result);
  }
}
